// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* All Workspaces page */
.rt-ws-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.rt-ws-muted {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--rt-text-muted, #64748b);
  font-size: var(--rt-text-sm, 13px);
}

/* Workspace monogram tile — hue derived from the name */
.rt-ws-tile {
  --ws-hue: 220;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.02em;
  color: hsl(var(--ws-hue) 65% 38%);
  background: hsl(var(--ws-hue) 85% 94%);
  border: 1px solid hsl(var(--ws-hue) 60% 86%);
}

.rt-ws-tile--sm {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 12px;
}

[data-theme='dark'] .rt-ws-tile {
  color: hsl(var(--ws-hue) 85% 78%);
  background: hsl(var(--ws-hue) 40% 20%);
  border-color: hsl(var(--ws-hue) 35% 30%);
}

.rt-ws-role {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: var(--rt-text-xs, 12px);
  font-weight: 500;
  color: var(--rt-text-secondary, #475569);
  background: var(--rt-surface-hover, #f1f5f9);
  border: 1px solid var(--rt-border-subtle, #e2e8f0);
}

.rt-ws-role--owner {
  color: var(--rt-warning, #b45309);
  background: color-mix(in srgb, var(--rt-warning, #f59e0b) 12%, transparent);
  border-color: color-mix(in srgb, var(--rt-warning, #f59e0b) 30%, transparent);
}

.rt-ws-current {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: var(--rt-text-xs, 12px);
  font-weight: 600;
  color: var(--rt-success, #15803d);
  background: color-mix(in srgb, var(--rt-success, #22c55e) 12%, transparent);
}

.rt-ws-current::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

/* Continue where you left off */
.rt-ws-resume {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: var(--rt-radius-lg, 12px);
  border: 1px solid color-mix(in srgb, var(--rt-primary, #2563eb) 25%, var(--rt-border, #e2e8f0));
  background: linear-gradient(
    100deg,
    color-mix(in srgb, var(--rt-primary, #2563eb) 8%, var(--rt-surface, #fff)) 0%,
    var(--rt-surface, #fff) 70%
  );
}

.rt-ws-resume__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.rt-ws-resume__eyebrow {
  font-size: var(--rt-text-xs, 12px);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-primary, #2563eb);
}

.rt-ws-resume__title {
  font-size: var(--rt-text-base, 15px);
  color: var(--rt-text, #0f172a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-ws-resume__project {
  font-weight: 500;
  color: var(--rt-text-secondary, #475569);
}

/* Toolbar */
.rt-ws-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.rt-ws-toolbar__search {
  flex: 1 1 280px;
  max-width: 420px;
}

.rt-ws-toolbar__count {
  margin-left: auto;
  color: var(--rt-text-muted, #64748b);
  font-size: var(--rt-text-sm, 13px);
}

.rt-ws-view {
  display: inline-flex;
  padding: 2px;
  border-radius: var(--rt-radius-md, 8px);
  border: 1px solid var(--rt-border, #e2e8f0);
  background: var(--rt-surface, #fff);
}

.rt-ws-view__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--rt-text-muted, #64748b);
  cursor: pointer;
  transition: background var(--rt-transition, 0.15s ease), color var(--rt-transition, 0.15s ease);
}

.rt-ws-view__btn:hover {
  color: var(--rt-text, #0f172a);
}

.rt-ws-view__btn.is-active {
  background: var(--rt-surface-hover, #f1f5f9);
  color: var(--rt-primary, #2563eb);
}

/* Grid */
.rt-ws-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
}

.rt-ws-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  padding: 16px;
  border-radius: var(--rt-radius-lg, 12px);
  border: 1px solid var(--rt-border, #e2e8f0);
  background: var(--rt-surface, #fff);
  box-shadow: var(--rt-shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
  transition: border-color var(--rt-transition, 0.15s ease), box-shadow var(--rt-transition, 0.15s ease),
    transform var(--rt-transition, 0.15s ease);
}

.rt-ws-card:hover {
  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 45%, var(--rt-border, #e2e8f0));
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.rt-ws-card:focus-visible {
  outline: 2px solid var(--rt-primary, #2563eb);
  outline-offset: 2px;
}

.rt-ws-card--current {
  border-color: color-mix(in srgb, var(--rt-success, #22c55e) 45%, var(--rt-border, #e2e8f0));
}

.rt-ws-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.rt-ws-card__menu {
  opacity: 0.6;
  transition: opacity var(--rt-transition, 0.15s ease);
}

.rt-ws-card:hover .rt-ws-card__menu,
.rt-ws-card:focus-within .rt-ws-card__menu {
  opacity: 1;
}

.rt-ws-card__title {
  margin: 0;
  font-size: var(--rt-text-base, 15px);
  font-weight: 600;
  color: var(--rt-text, #0f172a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-ws-card__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.rt-ws-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid var(--rt-border-subtle, #f1f5f9);
}

.rt-ws-card__open {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: var(--rt-text-sm, 13px);
  font-weight: 600;
  color: var(--rt-primary, #2563eb);
  transition: gap var(--rt-transition, 0.15s ease);
}

.rt-ws-card:hover .rt-ws-card__open {
  gap: 7px;
}

.rt-ws-card--new {
  align-items: center;
  justify-content: center;
  min-height: 168px;
  border-style: dashed;
  background: transparent;
  box-shadow: none;
  text-align: center;
}

.rt-ws-card--new__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: var(--rt-primary, #2563eb);
  background: color-mix(in srgb, var(--rt-primary, #2563eb) 10%, transparent);
}

.rt-ws-card--skeleton {
  min-height: 168px;
  cursor: default;
}

.rt-ws-card--skeleton:hover {
  transform: none;
  box-shadow: var(--rt-shadow-sm, none);
  border-color: var(--rt-border, #e2e8f0);
}

/* List view */
.rt-ws-name {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.rt-ws-name__text {
  font-weight: 600;
  color: var(--rt-text, #0f172a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-ws-row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

/* Create workspace dialog */
.rt-ws-create {
  width: min(92vw, 460px);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rt-ws-create__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.rt-ws-create__head .rt-dialog__title {
  margin: 0 0 4px;
}

.rt-ws-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rt-ws-field__label {
  font-size: var(--rt-text-sm, 13px);
  font-weight: 600;
  color: var(--rt-text, #0f172a);
}

.rt-ws-field__required {
  color: var(--rt-danger, #dc2626);
}

.rt-ws-field__input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border-radius: var(--rt-radius-md, 8px);
  border: 1px solid var(--rt-border, #e2e8f0);
  background: var(--rt-surface, #fff);
  color: var(--rt-text, #0f172a);
  font: inherit;
  transition: border-color var(--rt-transition, 0.15s ease), box-shadow var(--rt-transition, 0.15s ease);
}

.rt-ws-field__input:focus {
  outline: none;
  border-color: var(--rt-primary, #2563eb);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--rt-primary, #2563eb) 18%, transparent);
}

.rt-ws-field__hint {
  align-self: flex-end;
  font-size: var(--rt-text-xs, 12px);
  color: var(--rt-text-muted, #64748b);
}

.rt-ws-create__preview {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--rt-radius-md, 8px);
  background: var(--rt-surface-hover, #f8fafc);
  font-weight: 600;
  color: var(--rt-text, #0f172a);
  overflow: hidden;
}

.rt-ws-create__preview span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .rt-ws-toolbar__search {
    max-width: none;
  }

  .rt-ws-toolbar__count {
    margin-left: 0;
    order: 3;
    width: 100%;
  }

  .rt-ws-resume {
    flex-wrap: wrap;
  }
}

/* Shared with WorkspaceProjectSelectModal */
.error-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.3);
  border-radius: 0.5rem;
  color: #dc3545;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.error-message svg {
  flex-shrink: 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: var(--primary, #007bff);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-muted, #666);
  width: 100%;
  min-height: 100%;
}

.empty-state svg {
  color: var(--border-color, #e9ecef);
  margin-bottom: 1rem;
  opacity: 0.6;
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  margin: 0 0 1.5rem 0;
  font-size: 0.95rem;
}

.empty-state .btn {
  padding: 0.75rem 1.5rem;
}
.workspace-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 1rem;
}

.workspace-modal {
  background: var(--modal-background, var(--surface, white));
  color: var(--text-primary);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 16px;
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: workspaceModalSlideIn 0.3s ease-out;
}

@keyframes workspaceModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.workspace-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.15rem 1.35rem;
  border-bottom: 1px solid rgba(37, 99, 235, 0.22);
  background-color: #eff6ff;
  background-image:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    );
  color: #1e3a8a;
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.workspace-modal .modal-header h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #1e3a8a;
}

.workspace-modal .modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #64748b);
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
}

.workspace-modal .modal-close-btn:hover:not(:disabled) {
  background-color: var(--surface-hover, #f8fafc);
  color: var(--text-primary);
}

.workspace-modal .modal-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.workspace-modal .modal-body {
  padding: 1.5rem;
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
}

.workspace-modal .form-group {
  margin-bottom: 1.5rem;
}

.workspace-modal .form-group:last-child {
  margin-bottom: 0;
}

.workspace-modal .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary, #1a1a1a);
  font-size: 0.95rem;
}

.workspace-modal .form-group label .required {
  color: #dc3545;
}

.workspace-modal .form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 0.5rem;
  font-size: 0.95rem;
  color: var(--text-primary, #1a1a1a);
  background-color: var(--input-background, var(--surface, white));
  transition: all 0.2s ease;
  font-family: inherit;
}

.workspace-modal .form-input:focus {
  outline: none;
  border-color: var(--primary, #007bff);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.workspace-modal .form-input:disabled {
  background-color: var(--bg-secondary, #f8f9fa);
  cursor: not-allowed;
  opacity: 0.6;
}

.workspace-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.35rem;
  border-top: 1px solid var(--border, #e2e8f0);
  background: transparent;
  flex-shrink: 0;
}

.workspace-modal .btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-family: inherit;
}

.workspace-modal .btn-primary {
  background-color: var(--primary, #007bff);
  color: white;
}

.workspace-modal .btn-primary:hover:not(:disabled) {
  background-color: var(--primary-dark, #0056b3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.workspace-modal .btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.workspace-modal .btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.workspace-modal .btn-outline {
  background-color: transparent;
  border: 1px solid var(--border-color, #e9ecef);
  color: var(--text-primary, #1a1a1a);
}

.workspace-modal .btn-outline:hover:not(:disabled) {
  background-color: var(--bg-secondary, #f8f9fa);
  border-color: var(--text-muted, #666);
}

.workspace-modal .btn-outline:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.workspace-modal.project-select-modal {
  width: min(90vw, 640px);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.workspace-modal.project-select-modal .modal-body {
  /* overflow: hidden on both axes avoids CSS overflow pairing (visible + hidden → auto) */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.workspace-modal.project-select-modal .project-select-subtitle {
  margin: 0.35rem 0 0;
  color: var(--text-secondary, #475569);
  font-size: 0.8125rem;
}

.workspace-modal.project-select-modal .project-select-subtitle strong {
  color: var(--text-primary, #0f172a);
}

.workspace-modal.project-select-modal .project-select-error {
  margin-bottom: 1rem;
}

.workspace-modal.project-select-modal .project-select-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem 1rem;
  color: var(--text-muted, #666);
}

.workspace-modal.project-select-modal .form-group,
.workspace-modal.project-select-modal .project-select-error,
.workspace-modal.project-select-modal .project-select-loading,
.workspace-modal.project-select-modal .project-select-empty {
  flex-shrink: 0;
}

.workspace-modal.project-select-modal .project-select-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(50vh, 360px);
  overflow-y: auto;
  overflow-x: hidden;
}

.workspace-modal.project-select-modal .project-select-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0.9rem 1rem;
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 0.5rem;
  background-color: var(--surface, white);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.workspace-modal.project-select-modal .project-select-item:hover {
  border-color: var(--primary, #007bff);
  background-color: rgba(0, 123, 255, 0.04);
  transform: translateY(-1px);
}

.workspace-modal.project-select-modal .project-select-item-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.workspace-modal.project-select-modal .project-select-item-name {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workspace-modal.project-select-modal .project-select-item-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: var(--text-muted, #666);
  text-transform: capitalize;
  min-width: 0;
}

.workspace-modal.project-select-modal .project-select-item > svg {
  flex-shrink: 0;
}

.workspace-modal.project-select-modal .project-select-empty {
  padding: 2rem 1rem;
}


@media (max-width: 768px) {
  .workspace-modal.project-select-modal {
    width: min(95vw, 640px);
  }

  .workspace-modal .modal-header {
    padding: 1rem;
  }

  .workspace-modal .modal-header h2 {
    font-size: 1.1rem;
  }

  .workspace-modal .modal-body {
    padding: 1rem;
  }

  .workspace-modal .modal-footer {
    padding: 1rem;
    flex-direction: column-reverse;
  }

  .workspace-modal .modal-footer .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/all-workspaces.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,2EAA2E;EAC3E,6EAA6E;AAC/E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;EACxC,+FAA+F;EAC/F;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,+FAA+F;AACjG;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,2CAA2C;EAC3C,mCAAmC;EACnC,iEAAiE;EACjE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf;8CAC4C;AAC9C;;AAEA;EACE,2FAA2F;EAC3F,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;EACvC,2CAA2C;EAC3C,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,sGAAsG;AACxG;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,qFAAqF;AACvF;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,4CAA4C;EAC5C,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,QAAQ;EACR,yDAAyD;EACzD,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,0DAA0D;EAC1D,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kEAAkE;EAClE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,gDAAgD;EAChD,yBAAyB;EACzB;;;;;;KAMG;EACH,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,gEAAgE;EAChE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wFAAwF;EACxF,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;EAC9C,qBAAqB;EACrB,uCAAuC;EACvC,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* All Workspaces page */\n.rt-ws-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.rt-ws-muted {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--rt-text-muted, #64748b);\n  font-size: var(--rt-text-sm, 13px);\n}\n\n/* Workspace monogram tile — hue derived from the name */\n.rt-ws-tile {\n  --ws-hue: 220;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  color: hsl(var(--ws-hue) 65% 38%);\n  background: hsl(var(--ws-hue) 85% 94%);\n  border: 1px solid hsl(var(--ws-hue) 60% 86%);\n}\n\n.rt-ws-tile--sm {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n[data-theme='dark'] .rt-ws-tile {\n  color: hsl(var(--ws-hue) 85% 78%);\n  background: hsl(var(--ws-hue) 40% 20%);\n  border-color: hsl(var(--ws-hue) 35% 30%);\n}\n\n.rt-ws-role {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: var(--rt-text-xs, 12px);\n  font-weight: 500;\n  color: var(--rt-text-secondary, #475569);\n  background: var(--rt-surface-hover, #f1f5f9);\n  border: 1px solid var(--rt-border-subtle, #e2e8f0);\n}\n\n.rt-ws-role--owner {\n  color: var(--rt-warning, #b45309);\n  background: color-mix(in srgb, var(--rt-warning, #f59e0b) 12%, transparent);\n  border-color: color-mix(in srgb, var(--rt-warning, #f59e0b) 30%, transparent);\n}\n\n.rt-ws-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: var(--rt-text-xs, 12px);\n  font-weight: 600;\n  color: var(--rt-success, #15803d);\n  background: color-mix(in srgb, var(--rt-success, #22c55e) 12%, transparent);\n}\n\n.rt-ws-current::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n/* Continue where you left off */\n.rt-ws-resume {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  border-radius: var(--rt-radius-lg, 12px);\n  border: 1px solid color-mix(in srgb, var(--rt-primary, #2563eb) 25%, var(--rt-border, #e2e8f0));\n  background: linear-gradient(\n    100deg,\n    color-mix(in srgb, var(--rt-primary, #2563eb) 8%, var(--rt-surface, #fff)) 0%,\n    var(--rt-surface, #fff) 70%\n  );\n}\n\n.rt-ws-resume__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.rt-ws-resume__eyebrow {\n  font-size: var(--rt-text-xs, 12px);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-primary, #2563eb);\n}\n\n.rt-ws-resume__title {\n  font-size: var(--rt-text-base, 15px);\n  color: var(--rt-text, #0f172a);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-ws-resume__project {\n  font-weight: 500;\n  color: var(--rt-text-secondary, #475569);\n}\n\n/* Toolbar */\n.rt-ws-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.rt-ws-toolbar__search {\n  flex: 1 1 280px;\n  max-width: 420px;\n}\n\n.rt-ws-toolbar__count {\n  margin-left: auto;\n  color: var(--rt-text-muted, #64748b);\n  font-size: var(--rt-text-sm, 13px);\n}\n\n.rt-ws-view {\n  display: inline-flex;\n  padding: 2px;\n  border-radius: var(--rt-radius-md, 8px);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  background: var(--rt-surface, #fff);\n}\n\n.rt-ws-view__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 28px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--rt-text-muted, #64748b);\n  cursor: pointer;\n  transition: background var(--rt-transition, 0.15s ease), color var(--rt-transition, 0.15s ease);\n}\n\n.rt-ws-view__btn:hover {\n  color: var(--rt-text, #0f172a);\n}\n\n.rt-ws-view__btn.is-active {\n  background: var(--rt-surface-hover, #f1f5f9);\n  color: var(--rt-primary, #2563eb);\n}\n\n/* Grid */\n.rt-ws-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n}\n\n.rt-ws-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n  padding: 16px;\n  border-radius: var(--rt-radius-lg, 12px);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  background: var(--rt-surface, #fff);\n  box-shadow: var(--rt-shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color var(--rt-transition, 0.15s ease), box-shadow var(--rt-transition, 0.15s ease),\n    transform var(--rt-transition, 0.15s ease);\n}\n\n.rt-ws-card:hover {\n  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 45%, var(--rt-border, #e2e8f0));\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.rt-ws-card:focus-visible {\n  outline: 2px solid var(--rt-primary, #2563eb);\n  outline-offset: 2px;\n}\n\n.rt-ws-card--current {\n  border-color: color-mix(in srgb, var(--rt-success, #22c55e) 45%, var(--rt-border, #e2e8f0));\n}\n\n.rt-ws-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.rt-ws-card__menu {\n  opacity: 0.6;\n  transition: opacity var(--rt-transition, 0.15s ease);\n}\n\n.rt-ws-card:hover .rt-ws-card__menu,\n.rt-ws-card:focus-within .rt-ws-card__menu {\n  opacity: 1;\n}\n\n.rt-ws-card__title {\n  margin: 0;\n  font-size: var(--rt-text-base, 15px);\n  font-weight: 600;\n  color: var(--rt-text, #0f172a);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-ws-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.rt-ws-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: auto;\n  padding-top: 10px;\n  border-top: 1px solid var(--rt-border-subtle, #f1f5f9);\n}\n\n.rt-ws-card__open {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--rt-text-sm, 13px);\n  font-weight: 600;\n  color: var(--rt-primary, #2563eb);\n  transition: gap var(--rt-transition, 0.15s ease);\n}\n\n.rt-ws-card:hover .rt-ws-card__open {\n  gap: 7px;\n}\n\n.rt-ws-card--new {\n  align-items: center;\n  justify-content: center;\n  min-height: 168px;\n  border-style: dashed;\n  background: transparent;\n  box-shadow: none;\n  text-align: center;\n}\n\n.rt-ws-card--new__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  color: var(--rt-primary, #2563eb);\n  background: color-mix(in srgb, var(--rt-primary, #2563eb) 10%, transparent);\n}\n\n.rt-ws-card--skeleton {\n  min-height: 168px;\n  cursor: default;\n}\n\n.rt-ws-card--skeleton:hover {\n  transform: none;\n  box-shadow: var(--rt-shadow-sm, none);\n  border-color: var(--rt-border, #e2e8f0);\n}\n\n/* List view */\n.rt-ws-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.rt-ws-name__text {\n  font-weight: 600;\n  color: var(--rt-text, #0f172a);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-ws-row-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n/* Create workspace dialog */\n.rt-ws-create {\n  width: min(92vw, 460px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rt-ws-create__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rt-ws-create__head .rt-dialog__title {\n  margin: 0 0 4px;\n}\n\n.rt-ws-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rt-ws-field__label {\n  font-size: var(--rt-text-sm, 13px);\n  font-weight: 600;\n  color: var(--rt-text, #0f172a);\n}\n\n.rt-ws-field__required {\n  color: var(--rt-danger, #dc2626);\n}\n\n.rt-ws-field__input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px;\n  border-radius: var(--rt-radius-md, 8px);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  background: var(--rt-surface, #fff);\n  color: var(--rt-text, #0f172a);\n  font: inherit;\n  transition: border-color var(--rt-transition, 0.15s ease), box-shadow var(--rt-transition, 0.15s ease);\n}\n\n.rt-ws-field__input:focus {\n  outline: none;\n  border-color: var(--rt-primary, #2563eb);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--rt-primary, #2563eb) 18%, transparent);\n}\n\n.rt-ws-field__hint {\n  align-self: flex-end;\n  font-size: var(--rt-text-xs, 12px);\n  color: var(--rt-text-muted, #64748b);\n}\n\n.rt-ws-create__preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--rt-radius-md, 8px);\n  background: var(--rt-surface-hover, #f8fafc);\n  font-weight: 600;\n  color: var(--rt-text, #0f172a);\n  overflow: hidden;\n}\n\n.rt-ws-create__preview span:last-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 640px) {\n  .rt-ws-toolbar__search {\n    max-width: none;\n  }\n\n  .rt-ws-toolbar__count {\n    margin-left: 0;\n    order: 3;\n    width: 100%;\n  }\n\n  .rt-ws-resume {\n    flex-wrap: wrap;\n  }\n}\n\n/* Shared with WorkspaceProjectSelectModal */\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background-color: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  border-radius: 0.5rem;\n  color: #dc3545;\n  margin-bottom: 1.5rem;\n  flex-shrink: 0;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.error-message svg {\n  flex-shrink: 0;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top-color: var(--primary, #007bff);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n  text-align: center;\n  color: var(--text-muted, #666);\n  width: 100%;\n  min-height: 100%;\n}\n\n.empty-state svg {\n  color: var(--border-color, #e9ecef);\n  margin-bottom: 1rem;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary, #1a1a1a);\n  margin: 0 0 0.5rem 0;\n}\n\n.empty-state p {\n  margin: 0 0 1.5rem 0;\n  font-size: 0.95rem;\n}\n\n.empty-state .btn {\n  padding: 0.75rem 1.5rem;\n}\n.workspace-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  padding: 1rem;\n}\n\n.workspace-modal {\n  background: var(--modal-background, var(--surface, white));\n  color: var(--text-primary);\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 520px;\n  max-height: 90vh;\n  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: workspaceModalSlideIn 0.3s ease-out;\n}\n\n@keyframes workspaceModalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.workspace-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 1.15rem 1.35rem;\n  border-bottom: 1px solid rgba(37, 99, 235, 0.22);\n  background-color: #eff6ff;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    );\n  color: #1e3a8a;\n  border-radius: 16px 16px 0 0;\n  flex-shrink: 0;\n}\n\n.workspace-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #1e3a8a;\n}\n\n.workspace-modal .modal-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #64748b);\n  border-radius: 0.5rem;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n}\n\n.workspace-modal .modal-close-btn:hover:not(:disabled) {\n  background-color: var(--surface-hover, #f8fafc);\n  color: var(--text-primary);\n}\n\n.workspace-modal .modal-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.workspace-modal .modal-body {\n  padding: 1.5rem;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.workspace-modal .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.workspace-modal .form-group:last-child {\n  margin-bottom: 0;\n}\n\n.workspace-modal .form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-primary, #1a1a1a);\n  font-size: 0.95rem;\n}\n\n.workspace-modal .form-group label .required {\n  color: #dc3545;\n}\n\n.workspace-modal .form-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--text-primary, #1a1a1a);\n  background-color: var(--input-background, var(--surface, white));\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.workspace-modal .form-input:focus {\n  outline: none;\n  border-color: var(--primary, #007bff);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.workspace-modal .form-input:disabled {\n  background-color: var(--bg-secondary, #f8f9fa);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.workspace-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.35rem;\n  border-top: 1px solid var(--border, #e2e8f0);\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.workspace-modal .btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-family: inherit;\n}\n\n.workspace-modal .btn-primary {\n  background-color: var(--primary, #007bff);\n  color: white;\n}\n\n.workspace-modal .btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-dark, #0056b3);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.workspace-modal .btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.workspace-modal .btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.workspace-modal .btn-outline {\n  background-color: transparent;\n  border: 1px solid var(--border-color, #e9ecef);\n  color: var(--text-primary, #1a1a1a);\n}\n\n.workspace-modal .btn-outline:hover:not(:disabled) {\n  background-color: var(--bg-secondary, #f8f9fa);\n  border-color: var(--text-muted, #666);\n}\n\n.workspace-modal .btn-outline:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.workspace-modal.project-select-modal {\n  width: min(90vw, 640px);\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.workspace-modal.project-select-modal .modal-body {\n  /* overflow: hidden on both axes avoids CSS overflow pairing (visible + hidden → auto) */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.workspace-modal.project-select-modal .project-select-subtitle {\n  margin: 0.35rem 0 0;\n  color: var(--text-secondary, #475569);\n  font-size: 0.8125rem;\n}\n\n.workspace-modal.project-select-modal .project-select-subtitle strong {\n  color: var(--text-primary, #0f172a);\n}\n\n.workspace-modal.project-select-modal .project-select-error {\n  margin-bottom: 1rem;\n}\n\n.workspace-modal.project-select-modal .project-select-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2rem 1rem;\n  color: var(--text-muted, #666);\n}\n\n.workspace-modal.project-select-modal .form-group,\n.workspace-modal.project-select-modal .project-select-error,\n.workspace-modal.project-select-modal .project-select-loading,\n.workspace-modal.project-select-modal .project-select-empty {\n  flex-shrink: 0;\n}\n\n.workspace-modal.project-select-modal .project-select-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: min(50vh, 360px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.workspace-modal.project-select-modal .project-select-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 0.9rem 1rem;\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 0.5rem;\n  background-color: var(--surface, white);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.workspace-modal.project-select-modal .project-select-item:hover {\n  border-color: var(--primary, #007bff);\n  background-color: rgba(0, 123, 255, 0.04);\n  transform: translateY(-1px);\n}\n\n.workspace-modal.project-select-modal .project-select-item-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.workspace-modal.project-select-modal .project-select-item-name {\n  font-weight: 600;\n  color: var(--text-primary, #1a1a1a);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.workspace-modal.project-select-modal .project-select-item-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  font-size: 0.85rem;\n  color: var(--text-muted, #666);\n  text-transform: capitalize;\n  min-width: 0;\n}\n\n.workspace-modal.project-select-modal .project-select-item > svg {\n  flex-shrink: 0;\n}\n\n.workspace-modal.project-select-modal .project-select-empty {\n  padding: 2rem 1rem;\n}\n\n\n@media (max-width: 768px) {\n  .workspace-modal.project-select-modal {\n    width: min(95vw, 640px);\n  }\n\n  .workspace-modal .modal-header {\n    padding: 1rem;\n  }\n\n  .workspace-modal .modal-header h2 {\n    font-size: 1.1rem;\n  }\n\n  .workspace-modal .modal-body {\n    padding: 1rem;\n  }\n\n  .workspace-modal .modal-footer {\n    padding: 1rem;\n    flex-direction: column-reverse;\n  }\n\n  .workspace-modal .modal-footer .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
